'use strict';

const init = () => {
    document.querySelectorAll('.tc-website-newsletterblock .newsletter-form').forEach((newsletterForm) => {
        const loader = newsletterForm.querySelector('.techniconcept-loader')
        const fieldset = newsletterForm.querySelector('fieldset')

        newsletterForm.addEventListener('submit', (event) => {
            event.preventDefault();
            fieldset.classList.add('load');
            loader.classList.add('visible');

            const emailAddress = newsletterForm.querySelector('input.email').value;
            const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

            if (emailAddress && regex.test(emailAddress)) {
                let formFields = []
                formFields.push({
                    id: 'email',
                    value: emailAddress,
                    isValid: true
                })

                fetch(newsletterForm.getAttribute('action'), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({formFields: formFields, lang: document.documentElement.lang, newsletterForm: true})
                }).then(function (response) {
                    return response.json();
                }).then(function (data) {
                    const alertWrapper = newsletterForm.querySelector('.alert-wrapper');
                    alertWrapper.innerHTML = data.alert;
                    fieldset.parentNode.appendChild(alertWrapper);
                    loader.classList.remove('visible');
                    fieldset.classList.remove('load');

                    setTimeout(() => {
                        alertWrapper.classList.add('visible');
                    }, 0);

                    setTimeout(() => {
                        alertWrapper.classList.remove('visible');
                    }, 3000)
                }).catch(() => {
                    console.error('Error while newsletter registration');
                });
            } else {
                newsletterForm.querySelector('input.email').classList.add('error');
                loader.classList.remove('visible');
                fieldset.classList.remove('load');
            }
        })
    })
}

export default {init}
